import { useEffect, useRef, useState } from "react"

export const useFlash = (context: {
  isLoading: boolean
  response: unknown
  currentTab: string
}) => {
  const [flash, setFlash] = useState(false)
  const timer = useRef<NodeJS.Timeout>()
  const prevTotal = useRef<Record<string, number | undefined>>({})
  const total = (context.response as KosmosApi.Response<unknown>)?.metadata
    ?.total

  if (prevTotal.current[context.currentTab] === undefined)
    prevTotal.current[context.currentTab] = total

  const shouldFlash =
    !context.isLoading && prevTotal.current[context.currentTab] !== total

  useEffect(() => {
    if (!shouldFlash) return

    prevTotal.current[context.currentTab] = total
    setFlash(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFlash])

  useEffect(() => {
    if (!flash) return
    if (timer.current) clearTimeout(timer.current)

    timer.current = setTimeout(() => {
      setFlash(false)
    }, 1000)
  }, [flash])

  return flash || shouldFlash
}
